export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12858.d33974f3.jpg";